<template>
  <div :class="{ positionAbsolute_wrap: positionAbsolute }">
    <v-progress-circular
      :size="size"
      :indeterminate="indeterminate"
      :color="color"
      :width="width"
      class="pl-preloader"
      :class="{ positionAbsolute: positionAbsolute }"
    />
  </div>
</template>

<script>
export default {
  name: 'Preloader',
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: Number,
      default: 100,
    },
    width: {
      type: Number,
      default: 4,
    },
    indeterminate: {
      type: Boolean,
      default: true,
    },
    positionAbsolute: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style>
.v-progress-circular.positionAbsolute {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  transform: translateY(-50%);
}
.positionAbsolute_wrap {
  background: #f3f3f2;
  width: 100%;
  z-index: 999;
  position: 100%;
  position: absolute;
  height: 100%;
}
.preloader-enter-active,
.preloader-leave-active {
  transition: opacity 0.3s;
}
.preloader-enter, .preloader-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
